module.exports = __webpack_public_path__ + "static/media/premiere.866e25c9.svg";